export type PolygonPoint2D = [number, number];
export type PolygonLinePoint3D = [number, number, number];

export function createClosedPolygonLinePoints(
  points: readonly PolygonPoint2D[],
  z = 0,
): PolygonLinePoint3D[] {
  const [firstPoint] = points;
  if (!firstPoint) return [];

  return [...points, firstPoint].map(
    ([x, y]) => [x, y, z] as PolygonLinePoint3D,
  );
}
